/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$k as $k,
  rec_Componente_nA_110_65 as Componente_nA_110_65,
  rec_ImagenMarca as ImagenMarca,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function ImagenesMarca(e) {
  let t = (0, ReactCompiler.c)(7),
    { marca: n, onCambio: r, avisos: i, confirmar: a } = e,
    o;
  t[0] !== i || t[1] !== a || t[2] !== n?.archivos || t[3] !== r
    ? ((o = $k.map((e) => (
        <ImagenMarca
          key={e.id}
          def={e}
          url={n?.archivos?.[e.id]}
          onCambio={r}
          avisos={i}
          confirmar={a}
        />
      ))),
      (t[0] = i),
      (t[1] = a),
      (t[2] = n?.archivos),
      (t[3] = r),
      (t[4] = o))
    : (o = t[4]);
  let s;
  return (
    t[5] === o
      ? (s = t[6])
      : ((s = (
          <Componente_nA_110_65
            titulo={`Logos e imágenes`}
            ayuda={`Hasta 2 MB cada uno. Lo que no cargues usa la imagen que trae la aplicación.`}
            children={<ul className={`flex flex-col gap-2`} children={o} />}
          />
        )),
        (t[5] = o),
        (t[6] = s)),
    s
  );
}
